/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { Fragment, useEffect } from 'react'
import { defineMessages, useIntl, type MessageDescriptor } from 'react-intl'

import { getConfigForKey } from '@/store' // eslint-disable-line import/no-restricted-paths

const messages = defineMessages({
  ece: {
    id: 'routablePage.defaultTitle.ece',
    defaultMessage: 'Elastic Cloud Enterprise',
  },
  saas: {
    id: 'routablePage.defaultTitle.saas',
    defaultMessage: 'Elastic Cloud',
  },
})

const getDefaultTitle = (): MessageDescriptor =>
  getConfigForKey(`CLOUD_UI_APP`) === `cloud-enterprise-adminconsole` ? messages.ece : messages.saas

const RoutablePage: React.FunctionComponent<{ title?: string }> = ({ children, title }) => {
  const { formatMessage } = useIntl()

  useEffect(() => {
    document.title = title || formatMessage(getDefaultTitle())

    return () => {
      document.title = formatMessage(getDefaultTitle())
    }
  }, [title, formatMessage])

  return <Fragment>{children}</Fragment>
}

export default RoutablePage
